import { render, staticRenderFns } from "./EnrollmentList.vue?vue&type=template&id=fd2edab6"
import script from "./EnrollmentList.vue?vue&type=script&lang=js"
export * from "./EnrollmentList.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentList.vue?vue&type=style&index=0&id=fd2edab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports